import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Emitter } from "../util/Emitter";
export var BaseContext = /*#__PURE__*/function (_Emitter) {
  _inherits(BaseContext, _Emitter);
  function BaseContext() {
    var _this;
    _classCallCheck(this, BaseContext);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseContext).apply(this, arguments));
    _this.isOffline = false;
    return _this;
  }
  /*
   * This is a placeholder so that JSON.stringify does not throw an error
   * This matches what JSON.stringify(audioContext) returns on a native
   * audioContext instance.
   */
  _createClass(BaseContext, [{
    key: "toJSON",
    value: function toJSON() {
      return {};
    }
  }]);
  return BaseContext;
}(Emitter);